import React from "react";

var Logo = function Logo(_ref) {
  var logo = _ref.logo,
      videoState = _ref.videoState,
      scale = _ref.scale;
  var url = logo.url,
      _logo$size = logo.size,
      size = _logo$size === undefined ? "20%" : _logo$size,
      _logo$bottom = logo.bottom,
      bottom = _logo$bottom === undefined ? 30 : _logo$bottom,
      _logo$right = logo.right,
      right = _logo$right === undefined ? 30 : _logo$right,
      top = logo.top,
      left = logo.left;
  var containerStyle = {
    position: "absolute",
    top: 0,
    left: 0
  };

  if (videoState && videoState.readyState !== 0) {
    containerStyle.width = videoState.videoWidth * scale;
    containerStyle.height = videoState.videoHeight * scale;
  }

  return React.createElement("div", {
    style: containerStyle
  }, React.createElement("img", {
    src: url,
    style: {
      position: "absolute",
      zIndex: 11,
      maxWidth: size,
      maxHeight: size,
      bottom: bottom && bottom * scale,
      right: right && right * scale,
      top: top && top * scale,
      left: left && left * scale
    }
  }));
};

export default Logo;